import React, { useMemo, useState } from 'react';
import { IDNameDescriptionDictionary } from '../../models/Site';
import moment from 'moment';
import { IDNameDescriptionItemSelect } from '../../components/_IDNameDescriptionItemSelect';
import { SimulatorModel } from '../../models/SimulatorModel';
import { get, set } from 'lodash';
import { CustomerCardModel } from '../../models/CustomerCardModel';
import "../ClientsStyle.css"
import MessegePopupClient from '../_MessegePopupClient';

export interface ClientPolicyDetailsRiderProps {
    policyItem: any; // Replace 'any' with the actual type of policy if available
    authorizedToDrive: IDNameDescriptionDictionary;
    eventTypes: IDNameDescriptionDictionary;
    servicesProvider: IDNameDescriptionDictionary;
    passedTypeOfInsurance: IDNameDescriptionDictionary;
    collectionMethodtype: IDNameDescriptionDictionary;
    collectionRouteType: IDNameDescriptionDictionary;
    customerData: any;
}

const ClientPolicyDetailsRider: React.FC<ClientPolicyDetailsRiderProps> = ({
    policyItem,
    authorizedToDrive,
    eventTypes,
    servicesProvider,
    passedTypeOfInsurance,
    collectionMethodtype,
    collectionRouteType,
    customerData
}) => {
    const customerModel: CustomerCardModel = new CustomerCardModel();

    const [policy, setPolicy] = useState<any>(policyItem);
    const [oldPolicy, setOldPolicy] = useState<any>(policyItem);
    const [edit, setEdit] = useState(false);

    const [agemainDriver, setAgeMainDriver] = useState<string>("");
    const [ageYoungDriver, setAgeYoungDriver] = useState<string>("");

    const [showPopUp, setShowPopUp] = useState<boolean>(false);

    const policyData = useMemo(() => {

        const policy_data: Record<string, any> = {};

        if (policy && (policy.itemType === 'policy' || policy.itemType == undefined)) {
            policy_data['fullName'] = customerData.fullName ? customerData.fullName : '';
            policy_data['eventType'] = policy.policyAdditionDetails && policy.policyAdditionDetails.eventType ? policy.policyAdditionDetails.eventType : '';
            policy_data['policyNumber'] = policy.policyNumber ? policy.policyNumber : '';
            policy_data['brunchName'] = policy.policyAdditionDetails && policy.policyAdditionDetails.vehiclePolicyType == 6 ? "פוליסת חובה" :
                policy.policyAdditionDetails.route && policy.policyAdditionDetails.route.comment ? policy.policyAdditionDetails.route.comment : '';
            // policy_data['branchName'] = 'רכב';
            // policy_data['agentNumber'] = '23001';
            policy_data['licenseNumber'] = policy.policyAdditionDetails && policy.policyAdditionDetails.vehicle &&
                policy.policyAdditionDetails.vehicle.licenseNumber ? policy.policyAdditionDetails.vehicle.licenseNumber : '';
            policy_data['carYear'] = policy.policyAdditionDetails && policy.policyAdditionDetails.vehicle &&
                policy.policyAdditionDetails.vehicle.carYear ? policy.policyAdditionDetails.vehicle.carYear : '';
            policy_data['vehicleType'] = 'פרטי';
            policy_data['weightVolume'] = policy.policyAdditionDetails && policy.policyAdditionDetails.vehicle &&
                policy.policyAdditionDetails.vehicle.weightVolume ? policy.policyAdditionDetails.vehicle.weightVolume : '';
            policy_data['modelCode'] = policy.policyAdditionDetails && policy.policyAdditionDetails.vehicle &&
                policy.policyAdditionDetails.vehicle.modelCode ? policy.policyAdditionDetails.vehicle.modelCode : '';
            policy_data['vehicleSubModel'] = policy.policyAdditionDetails && policy.policyAdditionDetails.vehicle &&
                policy.policyAdditionDetails.vehicle.vehicleSubModel && policy.policyAdditionDetails.vehicle.vehicleSubModel.name ? policy.policyAdditionDetails.vehicle.vehicleSubModel.name : '';
            policy_data['vehicleId'] = policy.policyAdditionDetails && policy.policyAdditionDetails.vehicle && policy.policyAdditionDetails.vehicle.id ? policy.policyAdditionDetails.vehicle.id : '';
            policy_data['gearsType'] = policy.policyAdditionDetails && policy.policyAdditionDetails.vehicle && policy.policyAdditionDetails.vehicle.gearsType >= 0 ? policy.policyAdditionDetails.vehicle.gearsType == 1 ? 'אוטומט' : 'ידני' : '';
            policy_data['premia'] = policy.policyAdditionDetails && policy.policyAdditionDetails.premiumSum;
            policy_data['updatedDate'] = moment(customerData.updatedDate).format('DD/MM/YYYY');
            policy_data['authorizedToDrive'] = policy.policyAdditionDetails && policy.policyAdditionDetails.driversType ? policy.policyAdditionDetails.driversType : "";
            policy_data['numberOfPayments'] = policy.policyAdditionDetails && policy.policyAdditionDetails.numberOfPayments ? policy.policyAdditionDetails.numberOfPayments : "";
            policy_data['agentNumber'] = policy.policyAdditionDetails && policy.policyAdditionDetails.agentNumber ? policy.policyAdditionDetails.agentNumber : "";
            policy_data['eventDate'] = policy.policyAdditionDetails && policy.policyAdditionDetails.eventDate ? moment(policy.policyAdditionDetails.eventDate).format('DD/MM/YYYY') : "";
            policy_data['policyType'] = policy.policyType && (policy.policyType.policyTypeId == '1' || policy.policyType.policyTypeId == '12') ? 1 : 2; // 1 - policy,rider  . 2 - other
        } else if (policy && policy.itemType === 'rider') {
            policy_data['fullName'] = customerData.fullName ? customerData.fullName : '';
            policy_data['eventType'] = policy.policyAdditionDetails && policy.policyAdditionDetails.eventType ? policy.policyAdditionDetails.eventType : '';
            policy_data['policyNumber'] = policy.subscriberNumber ? policy.subscriberNumber : '';

            policy_data['brunchName'] = ""          // policy_data['agentNumber'] = '23001';
            policy_data['licenseNumber'] = policy.vehicle.licenseNumber ? policy.vehicle.licenseNumber : '';
            policy_data['carYear'] = policy.vehicle.carYear ? policy.vehicle.carYear : '';
            policy_data['vehicleType'] = 'פרטי';
            policy_data['weightVolume'] = policy.vehicle.weightVolume ? policy.vehicle.weightVolume : '';
            policy_data['modelCode'] = policy.vehicle.modelCode ? policy.vehicle.modelCode : '';
            policy_data['vehicleSubModel'] = policy.vehicle.vehicleSubModel && policy.vehicle.vehicleSubModel.name ? policy.vehicle.vehicleSubModel.name : '';
            policy_data['vehicleId'] = policy.vehicle && policy.vehicle.id ? policy.vehicle.id : '';
            policy_data['gearsType'] = policy.vehicle.gearsType == 1 ? 'אוטומט' : 'ידני';
            policy_data['updatedDate'] = moment(customerData.updatedDate).format('DD/MM/YYYY');
            policy_data['authorizedToDrive'] = "";
            policy_data['numberOfPayments'] = "";
            policy_data['agentNumber'] = "";
            policy_data['eventDate'] = "";
            policy_data['policyType'] = 1
            if (policy.riderPackages && policy.riderPackages.length > 0) {
                let totalCustomerCost: number = 0;
                policy.riderPackages.forEach((p: any) => {
                    totalCustomerCost += p.customerCost
                })
                policy_data['premia'] = totalCustomerCost;

            } else {
                policy_data['premia'] = "";
            }
        }

        // console.log('policy_data', policy.itemType, policy_data, policy);

        return policy_data;
    }, [policy]);

    const onChangeProtectionLevel = (e: any) => {
        const protectionValue = e.target.value;
        console.log(`Protectionlevel changed to: ${protectionValue}`);
        setPolicy((prevPolicy: any) => ({
            ...prevPolicy,
            vehicle: {
                ...prevPolicy.vehicle,
                protectionLevel: protectionValue
            }
        }));
    }


    const getPremia = () => {
        if (policy.itemType === 'policy') {
            return policy.policyAdditionDetails.premiumSum;
        } else if (policy.itemType === 'rider') {
            // If it's a rider, calculate the total customer cost from riderPackages
            if (policy.riderPackages && policy.riderPackages.length > 0) {
                let totalCustomerCost: number = 0;
                policy.riderPackages.forEach((p: any) => {
                    totalCustomerCost += p.customerCost
                })
                return totalCustomerCost;

            } else {
                return "";
            }
        }
        return "";
    };

    const onPrimaryDetailsChange = (field: string, value: any) => {
        // Handle primary details change logic here
        console.log(`Primary details field ${field} changed to ${value}`);
        setPolicy((prevPolicy: any) => ({
            ...prevPolicy,
            [field]: value
        }));
    };

    const onSave = async (e: any) => {
        e.preventDefault(); // Prevent default form submission behavior
        // Handle save logic here

        const usersStorage = localStorage.getItem('loggedUser');
        if (usersStorage) {
            const parsedUser = JSON.parse(usersStorage);
            if (parsedUser && parsedUser.id) {
                policy.handlerUserId = parsedUser.id;
            }
        }

        try {
            setEdit(false);

            // You can add your save logic here, such as making an API call to save the updated policy
            let res = await customerModel.policyUpdatePolicy(policy);
            console.log('res', res)
            if (res) {
                setShowPopUp(true);

                console.log('Policy updated successfully:', res);
                // Optionally, you can update the state or show a success message
            }
        } catch (error: any) {
            console.error('Error saving policy:', error);
            // Optionally, you can show an error message to the user
            alert('Error saving policy: ' + error.message);
        } finally {

            // setOldPolicy(policy);
        }

    }

    const onCancel = () => {
        // Handle cancel logic here
        console.log('Canceling changes');
        setPolicy(oldPolicy);
        setEdit(false);
    }

    const getCreatorIfo = (creatorUserId: string) => {
        const users = localStorage.getItem('usersList');
        if (!users) {
            return '';
        }
        const usersList = JSON.parse(users);
        if (!usersList || !Array.isArray(usersList) || usersList.length === 0) {
            return '';
        }
        const creatorUser = usersList.find((user: any) => user.id === creatorUserId);
        if (!creatorUser) {
            return '';
        }
        if (creatorUser.fullName && creatorUser.fullName.length > 0) {
            return creatorUser.fullName;
        }
        return creatorUserId ? creatorUserId : '';
    }


    const getUserFullInfo = (userId: string) => {
        const users = localStorage.getItem('usersList');
        if (!users) {
            return '';
        }
        const usersList = JSON.parse(users);
        if (!usersList || !Array.isArray(usersList) || usersList.length === 0) {
            return '';
        }
        const creatorUser = usersList.find((user: any) => user.id === userId);
        if (!creatorUser) {
            return '';
        }
        if (creatorUser.fullName && creatorUser.fullName.length > 0) {
            return creatorUser;
        }
        return creatorUser ? creatorUser : '';
    }


    return (
        <>
            {
                showPopUp &&
                <MessegePopupClient
                    onClose={() => setShowPopUp(false)}
                />
            }
            <div className="details-row" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', height: '35px' }}>
                <div className="row-title">
                    פרטי הפוליסה
                </div>

                {/* {!edit && (
                    <div className='btn-section-warper'>
                        <button className='btn-style' onClick={() => setEdit(true)}>
                            עריכה
                        </button>
                    </div>
                )}

                {edit && (
                    <div className='btn-section-warper'>
                        <button className='btn-style' onClick={onSave}>
                            שמירה
                        </button>
                        <button className='btn-style-cancel' onClick={onCancel}>
                            ביטול
                        </button>
                    </div>
                )} */}

            </div>

            <div style={{ maxHeight: '350px', overflowY: 'auto', borderBottom: '1px solid #9399b7' }} >
                <div className='white-bg flex-space-between'>
                    <div className="details-row white-bg flex-grow" style={{ flex: 'initial' }}>
                        <div className="row-sub-title">
                            כללי
                        </div>
                        <div className="policy-main-details" style={{ display: 'flex', gap: '40px' }}>
                            <div className="cell">
                                <div className="title">
                                    שם מבוטח
                                </div>
                                <div className="description cell-value">
                                    {policyData['fullName']}
                                </div>
                            </div>

                            <div className="cell">
                                <div className="title">
                                    מספר פוליסה/תוספת
                                </div>
                                <div className="description cell-value">
                                    {policyData['policyNumber']}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="details-row white-bg flex-grow">

                        <div className="row-sub-title">
                            פרטי הרכב
                        </div>
                        <div className="policy-main-details flex-space-between">
                            <div className="cell">
                                <div className="title">
                                    מספר רישוי
                                </div>
                                <div className="description cell-value">
                                    {policyData['licenseNumber']}
                                </div>
                            </div>
                            <div className="cell">
                                <div className="title">
                                    שנת יצור
                                </div>
                                <div className="description cell-value">
                                    {policyData['carYear']}
                                </div>
                            </div>
                            <div className="cell">
                                <div className="title">
                                    סוג הרכב
                                </div>
                                <div className="description cell-value">
                                    פרטי
                                </div>
                            </div>
                            <div className="cell">
                                <div className="title">
                                    קוד דגם
                                </div>
                                <div className="description cell-value">
                                    {policyData['modelCode']}
                                </div>
                            </div>
                            <div className="cell">
                                <div className="title">
                                    דגם
                                </div>
                                <div className="description cell-value">
                                    {policyData['vehicleSubModel']}
                                </div>
                            </div>
                            <div className="cell">
                                <div className="title">
                                    הנעה
                                </div>
                                <div className="description cell-value">
                                    {policyData['gearsType']}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <div className='white-bg flex-space-between'>
                    <div className="details-row white-bg flex-grow">
                        <div className="row-sub-title">
                            שרותי דרך
                        </div>
                        {/* <div className="cell fixed-width">
                            <div className="title">
                                ספק שרותי דרך
                            </div>
                            <div className="description cell-value">
                                <IDNameDescriptionItemSelect
                                    Disabled={!edit}
                                    OnChange={onAdditionalDetailsChange}
                                    Options={servicesProvider}
                                    Id={"roadServicesProvider"}
                                    Value={policy.policyAdditionDetails && policy.policyAdditionDetails.roadServicesProvider}
                                />
                            </div>
                        </div> */}
                        {policy.riderPackages && policy.riderPackages.length > 0 && policy.riderPackages.map((packageItem: any, index: number) => (
                            <div className="policy-main-details" style={{ display: 'flex', gap: '40px' }} key={index}>

                                <div className="cell fixed-width">
                                    <div className="title">
                                        שם החבילה
                                    </div>
                                    <div className="description cell-value">
                                        {packageItem.riderPackage && packageItem.riderPackage.name ? packageItem.riderPackage.name : ''}
                                    </div>
                                </div>
                                <div className="cell" style={{ width: '100%' }}>
                                    <div className="title">
                                        שירות - ספק
                                    </div>
                                    <div className="description cell-value">
                                        {packageItem.riderPackage && packageItem.riderPackage.riderPackageServicesString ? packageItem.riderPackage.riderPackageServicesString : ''}
                                    </div>
                                </div>
                            </div>

                        ))}
                    </div>
                </div>


                <div className='white-bg flex-space-between'>
                    <div className="details-row white-bg flex-grow">
                        <div className="row-sub-title">
                            גביה
                        </div>
                        <div className="policy-main-details flex-space-between">
                            <div className="cell fixed-width">
                                <div className="title">
                                    פרמיה לתשלום
                                </div>
                                <div className="description cell-value">
                                    {getPremia()}
                                </div>
                            </div>
                            <div className="cell fixed-width">
                                <div className="title">
                                    מטבע
                                </div>
                                <div className="description cell-value">
                                    ₪
                                </div>
                            </div>
                            <div className="cell fixed-width">
                                <div className="title">
                                    שיטת גביה
                                </div>
                                <div className="description cell-value">
                                    {/* <IDNameDescriptionItemSelect
                                    Disabled={!edit}
                                    OnChange={onAdditionalDetailsChange}
                                    Id={"collectionMethodType"} Options={collectionMethodtype}
                                    Value={policy.policyAdditionDetails && policy.policyAdditionDetails.collectionMethodType >= 0 ?
                                        policy.policyAdditionDetails.collectionMethodType : ''}
                                /> */}
                                </div>
                            </div>
                            <div className="cell fixed-width">
                                <div className="title">
                                    מסלול גביה
                                </div>
                                <div className="description cell-value">
                                    {/* <IDNameDescriptionItemSelect
                                    Disabled={!edit}
                                    OnChange={onAdditionalDetailsChange}
                                    Id={"collectionRouteType"} Options={collectionRouteType}
                                    Value={policy.policyAdditionDetails && policy.policyAdditionDetails.collectionRouteType >= 0 ?
                                        policy.policyAdditionDetails.collectionRouteType : ''}
                                /> */}
                                </div>
                            </div>
                            <div className="cell fixed-width">
                                <div className="title">
                                    תשלומים
                                </div>
                                <div className="description cell-value">
                                    {policyData['numberOfPayments']}
                                    {/* <input type="number" value={policy.policyAdditionDetails && policy.policyAdditionDetails.numberOfPayments}
                                    onChange={(e: any) => onAdditionalDetailsChange("numberOfPayments", e.target.value)} disabled={!edit} /> */}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="details-row white-bg flex-grow">
                        <div className="row-sub-title">
                            פרטי חשבון
                        </div>
                        <div className="policy-main-details flex-space-between">
                            <div className="cell fixed-width">
                                <div className="title">
                                    מספר חשבון
                                </div>
                                <div className="description cell-value">
                                    {/* <input type="text" value={policy.policyAdditionDetails && policy.policyAdditionDetails.bankAccountNumber}
                                    onChange={(e: any) => onAdditionalDetailsChange("bankAccountNumber", e.target.value)} disabled={!edit} /> */}

                                </div>
                            </div>
                            <div className="cell fixed-width">
                                <div className="title">
                                    בנק
                                </div>
                                <div className="description cell-value">
                                    {/* <input type="text" value={policy.policyAdditionDetails && policy.policyAdditionDetails.bankNumber}
                                    onChange={(e: any) => onAdditionalDetailsChange("bankNumber", e.target.value)} disabled={!edit} /> */}
                                </div>
                            </div>
                            <div className="cell fixed-width">
                                <div className="title">
                                    סניף
                                </div>
                                <div className="description cell-value">
                                    {/* <input type="text" value={policy.policyAdditionDetails && policy.policyAdditionDetails.bankBranchNumber}
                                    onChange={(e: any) => onAdditionalDetailsChange("bankBranchNumber", e.target.value)} disabled={!edit} /> */}
                                </div>
                            </div>
                            <div className="cell fixed-width">
                                <div className="title">
                                    שם בעל החשבון
                                </div>
                                <div className="description cell-value">
                                    {/* <input type="text" value={policy.policyAdditionDetails && policy.policyAdditionDetails.bankAccountOwner}
                                    onChange={(e: any) => onAdditionalDetailsChange("bankAccountOwner", e.target.value)} disabled={!edit} /> */}

                                </div>
                            </div>
                            <div className="cell fixed-width">
                                <div className="title">
                                    מספר התחייבות
                                </div>
                                <div className="description cell-value">
                                    {/* <input type="text" value={policy.policyAdditionDetails && policy.policyAdditionDetails.commitmentNumber} onChange={(e: any) => onAdditionalDetailsChange("commitmentNumber", e.target.value)} disabled={!edit} /> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='white-bg flex-space-between'>
                    <div className="details-row white-bg flex-grow">
                        <div className="row-sub-title">
                            פרטי אשראי
                        </div>
                        <div className="policy-main-details flex-space-between">
                            <div className="cell fixed-width">
                                <div className="title">
                                    מספר כרטיס
                                </div>
                                <div className="description cell-value">
                                </div>
                            </div>
                            <div className="cell fixed-width">
                                <div className="title">
                                    סוג
                                </div>
                                <div className="description cell-value">

                                </div>
                            </div>
                            <div className="cell fixed-width">
                                <div className="title">
                                    תוקף
                                </div>
                                <div className="description cell-value">
                                </div>
                            </div>
                            <div className="cell fixed-width">
                                <div className="title">
                                    בעל הכרטיס
                                </div>
                                <div className="description cell-value">
                                </div>
                            </div>
                            <div className="cell fixed-width">
                                <div className="title">
                                    CVV
                                </div>
                                <div className="description cell-value">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="details-row white-bg">
                    <div className="policy-main-details" style={{ display: 'flex', flexWrap: 'wrap', gap: '30px' }}>
                        <div className="cell  fixed-width">
                            <div className="title">
                                הוקם ע"י
                            </div>
                            <div className="description cell-value">
                            </div>
                        </div>
                        <div className="cell  fixed-width">
                            <div className="title">
                                עודכן ע"י
                            </div>
                            <div className="description cell-value">
                                {policy.handlerUserId ?  getCreatorIfo(policy.handlerUserId) : ''}
                            </div>
                        </div>
                        <div className="cell  fixed-width">
                            <div className="title">
                                תאריך עדכון
                            </div>
                            <div className="description cell-value">
                                {policyData['updatedDate']}
                            </div>
                        </div>
                        <div className="cell">
                            <div className="title">
                                הערות
                            </div>
                            <div className="description cell-value">
                                <input style={{ width: 500 }} type="text" value={policy.comments} onChange={(e: any) => onPrimaryDetailsChange("comment", e.target.value)} disabled={!edit} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </>
    );
};

export default ClientPolicyDetailsRider;